import { Schema, z } from 'zod';
import { BaseFieldDefinition, BaseFieldDefinitionSchema } from './base';

export namespace RichTextFieldDefinition {
  export const TYPE = 'richText';
}

/**
 * Field definition of type richtext
 * @typedef RichTextFieldDefinition
 * @property - type : type of the field.
 * @property - i18n : translatable properties of the field.
 */
export type RichTextFieldDefinition = BaseFieldDefinition & {
  type: typeof RichTextFieldDefinition.TYPE;
  i18n?: boolean;
};

export const RichTextFieldDefinitionSchema: Schema<RichTextFieldDefinition> =
  BaseFieldDefinitionSchema.and(
    z.object({
      type: z.literal(RichTextFieldDefinition.TYPE),
      i18n: z.boolean().optional()
    })
  );
